import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { propStr } from '../../../../helpers/custom-prop-types';
const SolutionOneTagItem = (props) => {
    const { name } = props;
    const link = useMemo(() => `/consultant/search?${stringify({ keyword: name, search: 'service' })}`, [name]);
    return (_jsx("li", { children: _jsx(Link, Object.assign({ to: link }, { children: `#${name}` })) }));
};
SolutionOneTagItem.propTypes = {
    name: propStr().isRequired,
};
export default SolutionOneTagItem;
